import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-select-config',
  templateUrl: './d-select-config.component.html',
  styles: []
})
export class DSelectConfigComponent extends DynamicComponentBase {
  static KEY = 'd-select-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}

  addRow() {
    const newRow = {
      value: '',
      label: ''
    };
    this.config.dataSource = [...this.config.dataSource, newRow];
  }
  deleteRow(i) {
    this.config.dataSource.splice(i, 1);
  }
}
